<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="ModalBaslik"
      :visible.sync="Durum"
      :before-close="Kapat"
      :v-loading="lo"
  >
    <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
             ref="Form">
      <el-row :gutter="24">

        <el-col :span="24">
          <el-form-item label="Bölge" prop="Bolge_id">
            <el-select v-model="Form.Bina_id" filterable placeholder="Bölge Seçiniz">
              <el-option
                  v-for="item in Bina"
                  :key="item.id"
                  :label="item.adi"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item label="Barkod" prop="barkod">
            <el-input type="text" v-model="Form.barkod" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="M.Durum" prop="mdurum">
            <el-input type="text" v-model="Form.MDurum" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Üretim Tarihi" prop="test">
            <el-date-picker type="date" placeholder="Üretim Tarihi" v-model="Form.Uyili" format="dd.MM.yyyy"
                            value-format="dd.MM.yyyy"></el-date-picker>
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item label="Firma" prop="Firma">
            <el-input type="text" v-model="Form.Firma" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Kat Sayısı" prop="kat">
            <el-input type="text" v-model="Form.kat" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>




      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="Kapat">İptal</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
    </div>
  </el-dialog>

</template>

<script>


export default {
  props: ['Bilgi', 'Durum','Tur'],
  data() {
    return {
      ModalBaslik: '',
      lo: false,
      Form: null,
      Bina: null,
      test: '',
      FormHata: {
        barkod: [{required: true, message: "Barkod Giriniz", trigger: 'blur'}],
      },

    }
  },
  methods: {
    Kapat() {
      this.$emit('Durum')
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          console.log(this.Bilgi)
          this.$store.dispatch(this.Tur, {...this.Form, path: 'asansor'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.$emit('Durum')
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                  //if (Tur == 'Post') this.$router.push("/bolge/");
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    }
  },
  created() {
    if (this.Bilgi) {
      this.Form = this.Bilgi
      this.ModalBaslik = this.Bilgi.barkod
    } else {
      this.Form = {}
      this.ModalBaslik = 'Asansör Ekle'
    }
    this.$store.dispatch("Get", {path: 'build'})
    .then(response => {
      this.Bina = response.Data
    })
  },
  watch: {
    Bilgi: function () {
      this.Form = this.Bilgi
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Bina/Comp/AsansorModal.vue